// extracted by mini-css-extract-plugin
module.exports = {"base":"HeaderMenu_base__2Saun","links":"HeaderMenu_links__3HPG6","link":"HeaderMenu_link__3Jpo3","controls":"HeaderMenu_controls__1-nM_","button":"HeaderMenu_button__2HC8h"};